import { render } from "./EnterTrailer.vue?vue&type=template&id=441fac9e&scoped=true&ts=true"
import script from "./EnterTrailer.vue?vue&type=script&lang=ts"
export * from "./EnterTrailer.vue?vue&type=script&lang=ts"

import "./EnterTrailer.vue?vue&type=style&index=0&id=441fac9e&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441fac9e"]])

export default __exports__